// extracted by css-extract-rspack-plugin
export default {"cls1":"MenuItem-cls1_r__","cls2":"MenuItem-cls2_N5K MenuItem-cls1_r__"};